import { createAsyncThunk, createSlice, isRejected } from '@reduxjs/toolkit';

import * as auth from '~/slices/auth';
import { userService } from '~/services';

const initialState = {
    errors: null,
};
Object.freeze(initialState);

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(login.fulfilled, (state, { payload }) => {
                Object.assign(state, payload);
            })
            .addCase(login.rejected, (state, { payload }) => {
                state.errors = payload;
            });
    },
});

export const login = createAsyncThunk(
    'user/login',
    async ({ email, password }, { rejectWithValue, dispatch }) => {
        const authLoginResponse = await dispatch(auth.loginAction({ email, password }));

        if (isRejected(authLoginResponse)) {
            return rejectWithValue(authLoginResponse.payload);
        }

        return await userService.fetchUserInfo().catch(rejectWithValue);
    }
);

export default userSlice.reducer;
